"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiOrdersClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
const OrderConverter_1 = require("../OrderConverter");
const types_1 = require("../../../types");
class ApiOrdersClient extends ApiSubClient_1.ApiSubClient {
    uploadOrdersCsv(orders) {
        const formData = new FormData();
        formData.append('file', orders);
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        const uploadLink = new types_1.Link(this.getLinkOrThrow('orders'));
        return this.axios
            .post(uploadLink.getTemplatedLink({}), formData, config)
            .then((response) => Promise.resolve({
            message: response.data.message,
        }))
            .catch((err) => {
            let reasons;
            let message = err.message;
            if ((0, types_1.isBoclipsApiError)(err)) {
                reasons = err.reasons;
            }
            else {
                const data = err.response?.data;
                if (data && (0, types_1.isBoclipsApiError)(data)) {
                    message = data.message;
                    reasons = data.reasons;
                }
            }
            return Promise.reject({
                message: message,
                reasons: reasons,
            });
        });
    }
    placeOrder(request) {
        const orderLink = this.getLinkOrThrow('placeOrder');
        return this.axios
            .post(orderLink.href, {
            items: request.cart.items,
            note: request.cart.note,
            user: {
                id: request.user.id,
                firstName: request.user.firstName,
                lastName: request.user.lastName,
                email: request.user.email,
                account: {
                    id: request.user.account?.id,
                    type: request.user.account?.type,
                    name: request.user.account?.name,
                },
            },
        }, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
            .then((it) => {
            return it.headers.location;
        });
    }
    get(id) {
        const orderLink = this.getLinkOrThrow('order');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(orderLink.href, { id }))
            .then((response) => {
            return OrderConverter_1.OrderConverter.convertResource(response);
        });
    }
    getAllWithinDates(dateFrom, dateTo) {
        const ordersLink = this.getLinkOrThrow('ordersWithinDates');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(ordersLink.href, {
            order_created_from: dateFrom,
            order_created_to: dateTo,
        }))
            .then((response) => {
            return OrderConverter_1.OrderConverter.convertEmbeddedResource(response);
        });
    }
    getUserOrders(page, size) {
        const ordersLink = this.getLinkOrThrow('userOrders');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(ordersLink.href, { page, size }))
            .then((response) => {
            return {
                page: OrderConverter_1.OrderConverter.convertEmbeddedResource(response),
                pageSpec: response.data.page,
            };
        });
    }
    updateOrder(order, updateRequest) {
        const orderLink = order.links.update.getOriginalLink();
        if (!orderLink) {
            throw Error('Not allowed to update order');
        }
        return this.axios
            .patch(orderLink, updateRequest, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
            .then((response) => {
            return OrderConverter_1.OrderConverter.convertResource(response);
        });
    }
    updateItem(item, updateRequest) {
        return this.axios
            .patch(item.links.update.getOriginalLink(), updateRequest, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
            .then((response) => {
            return OrderConverter_1.OrderConverter.convertResource(response);
        });
    }
    exportOrdersCsv(orderExportRequest) {
        const url = (0, expandUrlTemplate_1.default)(this.getLinkOrThrow('exportOrders').href, {
            ...orderExportRequest,
        });
        return this.axios
            .get(url, { headers: { accept: 'text/csv' } })
            .then((response) => {
            const disposition = response.headers && response.headers['content-disposition'];
            const filename = (disposition && /.*filename="([^"]*)"/.exec(disposition)?.[1]) ||
                'download';
            return {
                content: response.data,
                filename: filename,
                mimeType: 'text/csv',
            };
        });
    }
    getUploadOrdersCsvTemplate() {
        const url = (0, expandUrlTemplate_1.default)(this.getLinkOrThrow('orderCsvTemplate').href, {});
        return this.axios.get(url).then((response) => {
            const disposition = response.headers && response.headers['content-disposition'];
            const filename = (disposition && /.*filename="([^"]*)"/.exec(disposition)?.[1]) ||
                'download';
            return {
                content: response.data,
                filename: filename,
            };
        });
    }
    markItemReadyForLicense(item) {
        const markReadyForLicenseLink = item.links.markReadyForLicense?.getOriginalLink();
        if (!markReadyForLicenseLink) {
            throw Error('Not allowed to mark item ready for license');
        }
        return this.axios
            .patch(markReadyForLicenseLink, { isReadyForLicense: true }, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
            .then((response) => {
            return OrderConverter_1.OrderConverter.convertResource(response);
        });
    }
}
exports.ApiOrdersClient = ApiOrdersClient;
//# sourceMappingURL=ApiOrdersClient.js.map